import { DeskOpeningExceptionModel, DeskOpeningModel, TimelineOpening } from '../api/core/core.types';
import dayjs from 'dayjs';

const openingOverlap = (subject: TimelineOpening, target: TimelineOpening) => {
  return (!(dayjs(subject.validTo) < dayjs(target.validFrom) || (dayjs(subject.validFrom) > dayjs(target.validTo))));
};

const openingFitsInRow = (subject: TimelineOpening, openings: TimelineOpening[]) => {
  if (!openings.length) return true;
  // eslint-disable-next-line no-restricted-syntax
  for (const i of openings) {
    if (openingOverlap(subject, i)) return false;
  }

  return true;
};

const pushOpenings = (deskOpeningList: TimelineOpening[], matrix: TimelineOpening[][]) => {
  let mainOpeningRowIndex = 0;
  deskOpeningList.forEach((deskOpening) => {
    let isOpeningFitted = false;

    if (openingFitsInRow(deskOpening, matrix[mainOpeningRowIndex])) {
      matrix[mainOpeningRowIndex].push(deskOpening);
      isOpeningFitted = true;
    } else {
      if (mainOpeningRowIndex === 0) {
        matrix.unshift([ deskOpening ]);
        isOpeningFitted = true;
        mainOpeningRowIndex++;
      }

      let targetRowIndex = mainOpeningRowIndex - 1;
      while (targetRowIndex >= 0 && !isOpeningFitted) {
        if (openingFitsInRow(deskOpening, matrix[targetRowIndex])) {
          matrix[targetRowIndex].push(deskOpening);
          isOpeningFitted = true;
        }

        targetRowIndex--;
      }

      if (!isOpeningFitted) {
        matrix.unshift([ deskOpening ]);
        mainOpeningRowIndex++;
        isOpeningFitted = true;
      }
    }
  });
};

export function getDeskOpeningTimelineMatrix(deskOpenings: DeskOpeningModel[], deskOpeningExceptions: DeskOpeningExceptionModel[]) {
  const matrix: TimelineOpening[][] = [ [] ];
  let holidaysList: TimelineOpening[] = [];
  let deskOpeningList: TimelineOpening[] = [];
  if (deskOpeningExceptions && deskOpeningExceptions.length) {
    deskOpeningExceptions.forEach((openingException) => {

      const timelineOpening = {
        id: openingException.id,
        isException: true,
        statusType: openingException.statusType,
        validFrom: openingException.date,
      };

      holidaysList.push(timelineOpening);
    });
  }

  if (deskOpenings && deskOpenings.length) {
    deskOpenings.forEach((deskOpening) => {
      const timelineOpening = {
        id: deskOpening.id,
        isException: false,
        statusType: deskOpening.statusType,
        validFrom: deskOpening.validFrom,
        validTo: deskOpening.validTo
      };
      deskOpeningList.push(timelineOpening);
    });
  }
  holidaysList = holidaysList.sort((a, b) => dayjs(a.validFrom).diff(b.validFrom));
  deskOpeningList = deskOpeningList.sort((a, b) => a.id - b.id);
  pushOpenings(deskOpeningList, matrix);
  matrix.reverse();
  matrix.unshift(holidaysList);

  matrix.forEach((line, index) => {
    line.sort((a, b) => dayjs(a.validFrom).diff(b.validFrom));
  });

  return matrix;
}
